import { memo } from "react";

import { ProductSelectorPlaceholder } from "@react/sections/ProductHero/ProductSelector/ProductSelectorPlaceholder.view";
import { useSectionSettings } from "@react/sections/Root/SectionSettingsContext";

import { ProductSelectorView } from "./ProductSelector.view";
import {
  type ProductSelectorSettings,
  useProductSelector,
} from "./ProductSelectorContext";

type Props = {
  formatBtnText: {
    available: string;
    soldOut: string;
    waitlisted: string;
  };
  selectOption: string;
};
const ProductSelectorBase = ({ formatBtnText, selectOption }: Props) => {
  const {
    isLoading,
    label,
    productComboOptionIds,
    selectedIndex,
    selectedProductComboOption,
    selectedVariantsByIndex,
  } = useProductSelector();
  const {
    meta: {
      localization: { country, language },
    },
    settings: { intelligemsEnabled, klarnaEnabled, theme },
  } = useSectionSettings<ProductSelectorSettings>();

  if (isLoading) {
    return <ProductSelectorPlaceholder />;
  }

  return (
    <ProductSelectorView
      country={country}
      formatBtnText={formatBtnText}
      isIntelligemsEnabled={intelligemsEnabled}
      isKlarnaEnabled={klarnaEnabled}
      label={label}
      language={language}
      productComboOptionIds={productComboOptionIds}
      selectOption={selectOption}
      selectedIndex={selectedIndex}
      selectedProductComboOption={selectedProductComboOption}
      selectedVariantsByIndex={selectedVariantsByIndex}
      theme={theme}
    />
  );
};

export const ProductSelector = memo(ProductSelectorBase);
